import { GPSTrackingDeviceMetadata, MobileAppMetadata } from './device-metadata.interface';

export interface IDevicePosition {
    deviceId?: number;
    latitude?: number;
    longitude?: number;
    heading?: number;
    speed?: number;
    timestamp?: string;
    metadata?: MobileAppMetadata | GPSTrackingDeviceMetadata;
}
